import "./Home.css";
import React from "react";
import Header from "../components/Header";
import heroImage from '../assets/bildkueche.webp'; // Bild-Pfad anpassen
import InfoSection from "../components/Infosection";
import bildEins from '../assets/hochkant.jpg'; // Bild-Pfad anpassen
import {RevealSection} from "../util/Reveal";
import Gallery from "../components/GalleryContainer";
import Impressum from "../components/Impressum";

export default function Home() {

    // @ts-ignore
    return (
        <>
            {/* HERO / LANDING */}

            <div className="hero-wrapper">
                <Header/>
                <div className="picture-container">
                    <img src={heroImage} alt="großes Bild des Restaurants" className="main-image"/>
                    {/* Darkening Overlay */}
                    <div className="hero-overlay"></div>
                    {/* NEU: Hero Content in der Mitte */}
                    <div className="hero-content">
                        {/*<a*/}
                        {/*    href="mailto:info@lilithberlin.de?subject=Tischreservierung%20Anfrage"*/}
                        {/*    className="hero-btn"*/}
                        {/*>*/}
                        {/*    BOOK TABLE*/}
                        {/*</a>*/}
                        {/*<h2 id="herotext"> WELCOME!</h2>*/}
                    </div>

                    <div className="header-spacer"></div>
                </div>
            </div>
            {/* ABOUT US */}
            {/* Block 1: Philosophie */}
            <RevealSection id={"us"}>
                <InfoSection title="UNSERE PHILOSOPHIE" imageSrc={bildEins} description="
                    Lilith is a brunch and wine bar in the heart of Berlin-Charlottenburg.
Our concept brings together distinctive breakfast and lunch dishes, carefully selected wines, specialty coffee, ceremonial matcha and fine pâtisserie in an elegant yet relaxed setting.
We believe in quality, thoughtful details and warm, personal hospitality. Lilith is a place for long breakfasts, memorable lunches and relaxed evenings over a good glass of wine.
Welcome to Lilith."
                />
            </RevealSection>
            {/*<RevealSection className="reversed">*/}
            {/*    <InfoSection*/}
            {/*        title="DAS AUGE ISST MIT"*/}
            {/*        imageSrc={bildZwei}*/}
            {/*        description="Ästhetik, die man sehen und schmecken kann.*/}
            {/*         In unserer Galerie werfen wir einen Blick hinter die Kulissen*/}
            {/*         – von der präzisen Anrichteweise unserer Köche bis hin zu den natürlichen Texturen unserer handverlesenen Zutaten.*/}
            {/*       "*/}
            {/*    />*/}
            {/*</RevealSection>*/}
            {/*<RevealSection>*/}
            {/*    <section id={"gallerie"} className="gallery-section">*/}
            {/*        <Gallery/>*/}
            {/*    </section>*/}
            {/*</RevealSection>*/}
            {/*<RevealSection>*/}
                <section id={"impressum"} className="impressum-section">
                    <Impressum></Impressum>
                </section>
            {/*</RevealSection>*/}
        </>
    );
}